import React, { useEffect, useRef } from 'react';

const TYPE_CONFIG = {
  confirm: {
    accent: '#f43f5e',
    iconBg: 'rgba(244,63,94,0.12)',
    iconBorder: 'rgba(244,63,94,0.3)',
    icon: ({ animate }) => (
      <svg viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" fill="rgba(244,63,94,0.15)"
          stroke="rgba(244,63,94,0.7)" strokeWidth="1.5"
          style={animate ? { animation: 'wt-d-pop 0.35s cubic-bezier(0.34,1.56,0.64,1)' } : {}}/>
        <line x1="12" y1="8" x2="12" y2="13" stroke="#f43f5e" strokeWidth="2.2"/>
        <circle cx="12" cy="16.5" r="1" fill="#f43f5e"/>
      </svg>
    ),
    confirmStyle: { background: 'linear-gradient(135deg,#f43f5e,#e11d48)', color: '#fff', boxShadow: '0 4px 16px rgba(244,63,94,0.35)' },
    cancelStyle:  { background: 'var(--wt-surface,rgba(255,255,255,0.08))', border: '1px solid var(--wt-border,rgba(255,255,255,0.12))', color: 'var(--wt-text-primary)' },
  },
  warning: {
    accent: '#f59e0b',
    iconBg: 'rgba(245,158,11,0.12)',
    iconBorder: 'rgba(245,158,11,0.3)',
    icon: ({ animate }) => (
      <svg viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
          fill="rgba(245,158,11,0.18)" stroke="rgba(245,158,11,0.75)" strokeWidth="1.5"
          style={animate ? { animation: 'wt-d-pop 0.35s cubic-bezier(0.34,1.56,0.64,1)' } : {}}/>
        <line x1="12" y1="9" x2="12" y2="13" stroke="#f59e0b" strokeWidth="2.2"/>
        <circle cx="12" cy="17" r="1" fill="#f59e0b"/>
      </svg>
    ),
    confirmStyle: { background: 'linear-gradient(135deg,#f59e0b,#d97706)', color: '#fff', boxShadow: '0 4px 16px rgba(245,158,11,0.35)' },
    cancelStyle:  { background: 'var(--wt-surface,rgba(255,255,255,0.08))', border: '1px solid var(--wt-border,rgba(255,255,255,0.12))', color: 'var(--wt-text-primary)' },
  },
  info: {
    accent: '#0ABAB5',
    iconBg: 'rgba(10,186,181,0.12)',
    iconBorder: 'rgba(10,186,181,0.3)',
    icon: ({ animate }) => (
      <svg viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" fill="rgba(10,186,181,0.15)"
          stroke="rgba(10,186,181,0.7)" strokeWidth="1.5"
          style={animate ? { animation: 'wt-d-pop 0.35s cubic-bezier(0.34,1.56,0.64,1)' } : {}}/>
        <line x1="12" y1="11" x2="12" y2="16" stroke="#0ABAB5" strokeWidth="2.2"/>
        <circle cx="12" cy="8" r="1" fill="#0ABAB5"/>
      </svg>
    ),
    confirmStyle: { background: 'linear-gradient(135deg,#0ABAB5,#0891b2)', color: '#fff', boxShadow: '0 4px 16px rgba(10,186,181,0.35)' },
    cancelStyle:  { background: 'var(--wt-surface,rgba(255,255,255,0.08))', border: '1px solid var(--wt-border,rgba(255,255,255,0.12))', color: 'var(--wt-text-primary)' },
  },
  success: {
    accent: '#10b981',
    iconBg: 'rgba(16,185,129,0.12)',
    iconBorder: 'rgba(16,185,129,0.3)',
    icon: ({ animate }) => (
      <svg viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" fill="rgba(16,185,129,0.15)"
          stroke="rgba(16,185,129,0.7)" strokeWidth="1.5"
          style={animate ? { animation: 'wt-d-pop 0.35s cubic-bezier(0.34,1.56,0.64,1)' } : {}}/>
        <polyline points="7 12.5 10.5 16 17 9" stroke="#10b981" strokeWidth="2.2"
          style={animate ? { strokeDasharray:24, strokeDashoffset:24, animation:'wt-d-check 0.4s ease 0.15s forwards' } : {}}/>
      </svg>
    ),
    confirmStyle: { background: 'linear-gradient(135deg,#10b981,#059669)', color: '#fff', boxShadow: '0 4px 16px rgba(16,185,129,0.35)' },
    cancelStyle:  { background: 'var(--wt-surface,rgba(255,255,255,0.08))', border: '1px solid var(--wt-border,rgba(255,255,255,0.12))', color: 'var(--wt-text-primary)' },
  },
  delete: {
    accent: '#f43f5e',
    iconBg: 'rgba(244,63,94,0.12)',
    iconBorder: 'rgba(244,63,94,0.3)',
    icon: ({ animate }) => (
      <svg viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round"
        stroke="#f43f5e" strokeWidth="1.8"
        style={animate ? { animation: 'wt-d-pop 0.35s cubic-bezier(0.34,1.56,0.64,1)' } : {}}>
        <polyline points="3 6 5 6 21 6"/>
        <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
        <path d="M10 11v6M14 11v6"/>
        <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
      </svg>
    ),
    confirmStyle: { background: 'linear-gradient(135deg,#f43f5e,#e11d48)', color: '#fff', boxShadow: '0 4px 16px rgba(244,63,94,0.35)' },
    cancelStyle:  { background: 'var(--wt-surface,rgba(255,255,255,0.08))', border: '1px solid var(--wt-border,rgba(255,255,255,0.12))', color: 'var(--wt-text-primary)' },
  },
};

export default function WatrlyDialog({
  title       = 'تأكيد',
  message     = '',
  type        = 'confirm',
  confirmText = 'تأكيد',
  cancelText  = 'إلغاء',
  onConfirm,
  onCancel,
}) {
  const cfg = TYPE_CONFIG[type] || TYPE_CONFIG.confirm;
  const confirmBtnRef = useRef(null);
  const IconComp = cfg.icon;

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onCancel?.();
      if (e.key === 'Enter')  onConfirm?.();
    };
    document.addEventListener('keydown', handleKey);
    confirmBtnRef.current?.focus();
    return () => document.removeEventListener('keydown', handleKey);
  }, [onConfirm, onCancel]);

  return (
    <div
      dir="rtl"
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '1rem', fontFamily: "'Cairo', sans-serif",
      }}
    >
      <style>{`
        @keyframes wt-d-fade  { from{opacity:0} to{opacity:1} }
        @keyframes wt-d-up    { from{opacity:0;transform:scale(0.88) translateY(18px)} to{opacity:1;transform:scale(1) translateY(0)} }
        @keyframes wt-d-pop   { 0%{transform:scale(0.5);opacity:0} 70%{transform:scale(1.15)} 100%{transform:scale(1);opacity:1} }
        @keyframes wt-d-check { from{stroke-dashoffset:24} to{stroke-dashoffset:0} }
      `}</style>

      {/* Backdrop */}
      <div
        onClick={onCancel}
        style={{
          position: 'absolute', inset: 0,
          background: 'rgba(0,0,0,0.55)',
          backdropFilter: 'blur(6px)',
          WebkitBackdropFilter: 'blur(6px)',
          animation: 'wt-d-fade 0.2s ease',
        }}
      />

      {/* Card */}
      <div
        style={{
          position: 'relative', width: '100%', maxWidth: '22rem',
          borderRadius: '1.25rem', overflow: 'hidden',
          background: 'var(--wt-surface, rgba(8,24,44,0.92))',
          backdropFilter: 'blur(32px) saturate(200%)',
          WebkitBackdropFilter: 'blur(32px) saturate(200%)',
          border: `1px solid ${cfg.accent}33`,
          boxShadow: `0 24px 60px rgba(0,0,0,0.45), 0 0 0 1px ${cfg.accent}22`,
          animation: 'wt-d-up 0.25s cubic-bezier(0.34,1.56,0.64,1)',
        }}
      >
        {/* Top accent line */}
        <div style={{ height: 3, background: `linear-gradient(90deg, transparent, ${cfg.accent}, transparent)` }} />

        <div style={{ padding: '1.25rem 1.25rem 1rem' }}>
          {/* Icon + Title */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.875rem', marginBottom: '1rem' }}>
            <div style={{
              width: 46, height: 46, borderRadius: '0.875rem', flexShrink: 0,
              background: cfg.iconBg, border: `1px solid ${cfg.iconBorder}`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <div style={{ width: 26, height: 26 }}>
                <IconComp animate />
              </div>
            </div>
            <div style={{ flex: 1, paddingTop: '0.2rem' }}>
              <h3 style={{
                margin: 0, fontSize: '0.95rem', fontWeight: 800,
                color: 'var(--wt-text-primary, rgba(240,249,255,0.95))',
                lineHeight: 1.3, marginBottom: '0.25rem',
              }}>{title}</h3>
              {message && (
                <p style={{
                  margin: 0, fontSize: '0.78rem', lineHeight: 1.55,
                  color: 'var(--wt-text-muted, rgba(186,230,253,0.55))',
                }}>{message}</p>
              )}
            </div>
          </div>

          {/* WTRLY divider */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
            <div style={{ flex: 1, height: 1, background: 'var(--wt-divider, rgba(56,189,248,0.1))' }} />
            <span style={{
              fontSize: '0.58rem', fontWeight: 800, letterSpacing: '0.18em',
              color: 'var(--wt-text-muted, rgba(186,230,253,0.3))',
              userSelect: 'none',
            }}>WTRLY</span>
            <div style={{ flex: 1, height: 1, background: 'var(--wt-divider, rgba(56,189,248,0.1))' }} />
          </div>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: '0.625rem' }}>
            <button
              ref={confirmBtnRef}
              onClick={onConfirm}
              style={{
                flex: 1, padding: '0.7rem', borderRadius: '0.75rem',
                fontSize: '0.82rem', fontWeight: 800, border: 'none',
                cursor: 'pointer', transition: 'all 0.18s ease',
                fontFamily: "'Cairo', sans-serif",
                ...cfg.confirmStyle,
              }}
              onMouseEnter={e => e.currentTarget.style.filter = 'brightness(1.1)'}
              onMouseLeave={e => e.currentTarget.style.filter = ''}
            >
              {confirmText}
            </button>
            {cancelText && (
              <button
                onClick={onCancel}
                style={{
                  flex: 1, padding: '0.7rem', borderRadius: '0.75rem',
                  fontSize: '0.82rem', fontWeight: 700, cursor: 'pointer',
                  transition: 'all 0.18s ease', fontFamily: "'Cairo', sans-serif",
                  ...cfg.cancelStyle,
                }}
                onMouseEnter={e => e.currentTarget.style.opacity = '0.8'}
                onMouseLeave={e => e.currentTarget.style.opacity = '1'}
              >
                {cancelText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
